export const gas = {
    send: 80000,
    vote: 80000,
    delegate: 160000,
    un_delegate: 200000,
    re_delegate: 300000,
    claim_reward: 120000,
};
